import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActionService } from "src/app/services/action.service";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent implements OnInit {
  constructor(private dataService: ActionService, private router: Router) {}

  ngOnInit(): void {
    this.dataService.logout();
    this.router.navigateByUrl("/login");
  }
}
